import { styled } from "@mui/material";
import { Link } from "../../vendor/react-router-dom/dist/index.js";
import { shouldNotForwardProps } from "../../utils/shouldNotForwardProps.js";
import { LINK_DISABLED_CLASSNAME } from "./constants.js";
const sizeStyles = {
  sm: {
    gap: "3px"
  },
  md: {
    gap: "6px"
  },
  lg: {
    gap: "6px"
  },
  xl: {
    gap: "6px"
  }
}, commonLinkStyles = {
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  textDecoration: "none",
  [`&.${LINK_DISABLED_CLASSNAME}`]: {
    color: (t) => `${t.palette.btn.solid.content.disabled}!important`,
    pointerEvents: "none"
  }
}, colorStyles = {
  primary: {
    color: (t) => t.palette.primary[900],
    "@media (hover: hover)": {
      "&:hover": {
        color: (t) => t.palette.primary[800]
      }
    },
    "&:active": {
      color: (t) => t.palette.primary[1e3]
    }
  },
  secondary: {
    color: (t) => t.palette.secondary[900],
    "@media (hover: hover)": {
      "&:hover": {
        color: (t) => t.palette.secondary[800]
      }
    },
    "&:active": {
      color: (t) => t.palette.secondary[1e3]
    }
  },
  tertiary: {
    color: (t) => t.palette.grey[400],
    "@media (hover: hover)": {
      "&:hover": {
        color: (t) => t.palette.grey[500]
      }
    },
    "&:active": {
      color: (t) => t.palette.grey[600]
    }
  },
  quaternary: {
    color: (t) => t.palette.grey[800],
    "@media (hover: hover)": {
      "&:hover": {
        color: (t) => t.palette.grey[700]
      }
    },
    "&:active": {
      color: (t) => t.palette.grey[1e3]
    }
  },
  invert: {
    color: (t) => t.palette.white.main,
    "@media (hover: hover)": {
      "&:hover": {
        color: (t) => t.palette.grey[100]
      }
    },
    "&:active": {
      color: (t) => t.palette.grey[200]
    }
  }
}, sizeIconStyles = {
  sm: {
    width: "12px",
    height: "12px"
  },
  md: {
    width: "18px",
    height: "18px"
  },
  lg: {
    width: "18px",
    height: "18px"
  },
  xl: {
    width: "18px",
    height: "18px"
  }
}, StyledIcon = styled("div")(
  ({ size }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    ...size ? sizeIconStyles[size] : {},
    svg: {
      width: "100%",
      height: "100%"
    }
  })
), StyledLink = styled(Link)(), StyledAnchor = styled(
  "a",
  shouldNotForwardProps(["disabled", "sx"])
)();
export {
  StyledAnchor,
  StyledIcon,
  StyledLink,
  colorStyles,
  commonLinkStyles,
  sizeStyles
};
//# sourceMappingURL=styles.js.map
